const OB_SESSION_KEY = 'ob-disbursement-session';
const OB_SELECTED_ACCOUNT_KEY = 'ob-disbursement-selected-account';
const OB_CALLBACK_STATUS_KEY = 'ob-disbursement-callback-status';

export type ObDisbursementCallbackStatus = 'select' | 'success' | 'error';

export type ObDisbursementSession = {
  applicantId: string;
  sessionId: string;
  accountId: string;
};

export type SelectedAccountInfo = {
  title: string;
  subtitle: string;
};

export const storeObDisbursementSession = (session: ObDisbursementSession) => {
  sessionStorage.setItem(OB_SESSION_KEY, JSON.stringify(session));
};

export const getObDisbursementSession = (): ObDisbursementSession | null => {
  const raw = sessionStorage.getItem(OB_SESSION_KEY);
  if (!raw) return null;
  try {
    return JSON.parse(raw);
  } catch {
    return null;
  }
};

export const clearObDisbursementSession = () => {
  sessionStorage.removeItem(OB_SESSION_KEY);
};

export const storeSelectedAccount = (info: SelectedAccountInfo) => {
  sessionStorage.setItem(OB_SELECTED_ACCOUNT_KEY, JSON.stringify(info));
};

export const getSelectedAccount = (): SelectedAccountInfo | null => {
  const raw = sessionStorage.getItem(OB_SELECTED_ACCOUNT_KEY);
  if (!raw) return null;
  try {
    return JSON.parse(raw);
  } catch {
    return null;
  }
};

export const clearSelectedAccount = () => {
  sessionStorage.removeItem(OB_SELECTED_ACCOUNT_KEY);
};

export const storeObCallbackStatus = (status: ObDisbursementCallbackStatus) => {
  sessionStorage.setItem(OB_CALLBACK_STATUS_KEY, status);
};

export const getObCallbackStatus = (): ObDisbursementCallbackStatus | null => {
  return sessionStorage.getItem(
    OB_CALLBACK_STATUS_KEY,
  ) as ObDisbursementCallbackStatus | null;
};

export const clearObCallbackStatus = () => {
  sessionStorage.removeItem(OB_CALLBACK_STATUS_KEY);
};
